<!--
Copyright (c) 2026 BarD Software s.r.o.
-->
<template>
    <div class="modal fade" id="modal-apply-promo" tabindex="-1" role="dialog"
         aria-labelledby="modal-apply-promo-title" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-apply-promo-title">Apply Promo Code</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <div class="form-group">
                            <label for="modal-apply-promo-code">Promo code</label>
                            <input type="text" class="form-control" id="modal-apply-promo-code"
                                   placeholder="Enter your promo code"
                                   v-model="code"
                                   @keyup.enter="onEnter">
                        </div>
                        <div class="alert alert-danger" role="alert" v-if="isError">
                            {{ errorMessage }}
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <BtnSubmit title="Apply" spinner ref="submitButton" :disabled="code.trim() === ''" :submitHandler="applyPromo">
                    </BtnSubmit>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Ref, Vue} from 'vue-facing-decorator';
import {BillingApplyPromo, BillingApplyPromoResponse} from '../Routes';
import BtnSubmit from './BtnSubmit.vue';

import $ from 'jquery';

@Component({
    components: {BtnSubmit},
})
export default class PromoCodeModal extends Vue {

  @Prop()
  public onSuccess: (credit: number) => void;
  private code: string = '';
  private billingRefid: string = '';
  private isError: boolean = false;
  private errorMessage: string = '';

  @Ref
  private submitButton!: BtnSubmit;

  public mounted() {
    $('#modal-apply-promo').on('shown.bs.modal', () => $('#modal-apply-promo-code').trigger('focus'));
  }

  private onEnter() {
    if (this.code.trim() !== '') {
      this.submitButton.submit();
    }
  }

  private applyPromo(): JQueryPromise<any> {
    this.isError = false;
    return BillingApplyPromo.invoke({
      code: this.code.trim(),
      billingRefid: this.billingRefid,
    }).then((response: BillingApplyPromoResponse) => {
      this.hide();
      this.onSuccess(response.credit);
    }).fail((jqXhr: JQueryXHR) => {
      this.errorMessage = jqXhr.status === 404
          ? 'This promo code is invalid or has already been used.'
          : 'Failed to apply the promo code. Please try again later.';
      this.isError = true;
    });
  }

  private hide() {
    $('#modal-apply-promo').modal('hide');
    this.code = '';
    this.isError = false;
  }

  public applyPromoCode(billingRefid: string) {
    this.billingRefid = billingRefid;
    this.code = '';
    this.isError = false;
    $('#modal-apply-promo').modal('show');
  }
}
</script>
